import React, { Suspense, useEffect, useState } from "react";
import swal from "sweetalert";

// Theme
import GlobalStyles, { Theme, ThemeProvider } from "./components/GlobalStyles";

// App Provider
import AppProvider, {
  cfgInProps,
  deviceCfgInProps,
  mypagecfgInProps,
  phonecfgInProps,
  userinfoInProps,
} from "./components/AppProvider";

// UI
import { Loading } from "./components/UI/Loading";

// Views
import PhoneInfoGenerator from "./components/PhoneInfoGenerator";
import UserInfoGenerator from "./components/UserInfoGenerator";
import Views from "./views";

export default () => {
  const [loaded, setLoaded] = useState(false);
  const [auth, setAuth] = useState("");
  const [userinfo, setuserinfo] = useState(userinfoInProps);
  const [cfg, setCfg] = useState(cfgInProps);
  const [mypagecfg, setMypageCfg] = useState(mypagecfgInProps);
  const [phonecfg, setPhoneCfg] = useState(phonecfgInProps);

  const [deviceCfg, setDeviceCfg] = useState(deviceCfgInProps);

  const preLoad = async () => {
    try {
      // To-Do 인증 작업
      setLoaded(true);
    } catch (e) {
      swal({ title: "오류", text: e.message }).then(() => {
        document.location.reload();
      });
    }
  };

  useEffect(() => {
    preLoad();
  }, []);

  if (!loaded) {
    return (
      <ThemeProvider theme={Theme}>
        <Loading />
        <GlobalStyles />
      </ThemeProvider>
    );
  }

  const provided = { auth, userinfo, cfg, mypagecfg, phonecfg, deviceCfg };
  return (
    <ThemeProvider theme={Theme}>
      <AppProvider {...provided}>
        <PhoneInfoGenerator>
          <UserInfoGenerator>
            <Suspense fallback={<div>Loading.</div>}>
              <Views />
            </Suspense>
            <GlobalStyles />
          </UserInfoGenerator>
        </PhoneInfoGenerator>
      </AppProvider>
    </ThemeProvider>
  );
};
